export const STORAGE_USER = `211SENSEZ9`;
export const STORAGE_USER_DATA = `loggedInData`;
export const AUTH_USER_DATA = `authData`;
